import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/common/Button';

export default function FeedbackModal({ onClose, onSubmit }) {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    return onSubmit(value);
  };

  return (
    <Dialog open onClose={onClose} disableBackdropClick>
      <DialogTitle>Milestone Feedback</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter feedback for this milestone. This feedback will be shared with
          student's guardians.
        </DialogContentText>
        <TextField
          multiline
          placeholder="Enter your feedback here..."
          variant="outlined"
          rows={6}
          rowsMin={6}
          autoFocus
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!value}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
